
import * as types from '../mutation-types';
import {
  get_languages
} from '@/api/lang';

export const state = {
  locale: 'en',
  locales: [],

}

export const getters = {
  locale: state => state.locale,
  locales: state => state.locales,
}
export const mutations = {
  [types.SET_LOCALE](state, { locale }) {
    state.locale = locale
  },
  [types.LANGUAGUES](state, payload) {
  }
  ,
  [types.LANGUAGUES_FAIL](state, payload) {
    state.locales = [];
  }
  ,
  [types.LANGUAGUES_SUCCESS](state, payload) {
    state.locales = payload;
  }
}
export const actions = {
  setLocale({ commit }, { locale }) {
    commit(types.SET_LOCALE, { locale })
  },
  async fetchLangs({ commit }, payload) {
    commit(types.LANGUAGUES);
    try {
      let data = await get_languages();
      commit(types.LANGUAGUES_SUCCESS, data)
    } catch (error) {
      commit(types.LANGUAGUES_FAIL, error)
    }
  }
}
